export const BUSINESS = {
  name: "BLVDS Detailing",
  tagline: "NYC's Premier Mobile Car Detailing",
  phone: "+19293795527",
  phoneDisplay: "(929) 379-5527",
  whatsapp: "19293795527",
  email: "Blvdsdetailing1@gmail.com",
  serviceArea: "Queens, Brooklyn & Long Island",
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d201299.8895!2d-73.9!3d40.72!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1700000000000",
  instagram: "https://www.instagram.com/blvds.szn_detailing/?utm_source=ig_web_button_share_sheet",
  tiktok: "https://www.tiktok.com/@blvds.detailing?is_from_webapp=1&sender_device=pc",
};

export const SERVICES = [
  {
    id: "basic_wash" as const,
    name: "Basic Wash",
    price: 50,
    priceCents: 5000,
    duration: "45 min",
    tagline: "Quick & spotless exterior refresh",
    features: [
      "Hand wash exterior",
      "Wheels & tires cleaned",
      "Spot-free rinse",
      "Streak-free dry",
      "Tire shine",
    ],
    highlight: false,
  },
  {
    id: "full_detail" as const,
    name: "Full Detail",
    price: 120,
    priceCents: 12000,
    duration: "2.5 hrs",
    tagline: "Showroom-fresh inside and out",
    features: [
      "Everything in Basic Wash",
      "Deep interior vacuum",
      "Dashboard & trim wipe-down",
      "Window cleaning (in & out)",
      "Leather/fabric conditioning",
      "Door jambs detailed",
    ],
    highlight: true,
  },
  {
    id: "premium_package" as const,
    name: "Premium Package",
    price: 250,
    priceCents: 25000,
    duration: "6+ hrs",
    tagline: "Mirror finish that lasts years",
    features: [
      "Everything in Full Detail",
      "Single-stage paint correction",
      "Ceramic coating (12-month)",
      "Headlight restoration",
      "Engine bay detail",
      "Premium leather treatment",
    ],
    highlight: false,
  },
];

export const SERVICE_BY_ID = Object.fromEntries(
  SERVICES.map((s) => [s.id, s])
) as Record<(typeof SERVICES)[number]["id"], (typeof SERVICES)[number]>;

export const REVIEWS = [
  {
    name: "Marcus T.",
    location: "Astoria, Queens",
    rating: 5,
    text: "Booked the Premium Package for my matte black M3. The ceramic coat is unreal water beads off like a Tesla commercial. Worth every penny.",
  },
  {
    name: "Priya S.",
    location: "Park Slope, Brooklyn",
    rating: 5,
    text: "They came right to my driveway in Park Slope. Interior was destroyed after a road trip with kids left it looking brand new. Highly recommend.",
  },
  {
    name: "Daniel K.",
    location: "Long Beach, LI",
    rating: 5,
    text: "Most professional detailers I've ever used. On-time, polite, and the result speaks for itself. My white SUV is blinding now.",
  },
  {
    name: "Sofia R.",
    location: "Forest Hills, Queens",
    rating: 5,
    text: "Full Detail every 6 weeks they remember my car, my preferences, everything. This is what premium service looks like.",
  },
];
